import { render, staticRenderFns } from "./PlayerEmbed.vue?vue&type=template&id=ef06c31a&"
import script from "./PlayerEmbed.vue?vue&type=script&lang=js&"
export * from "./PlayerEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports